import { REF_ENTITY_CONFIG } from "./extraFieldTypes";

export const ORDER_SERVICE_FIELD_TYPES = [
  { value: "TEXT", label: "Text" },
  { value: "TEXTAREA", label: "Text Area" },
  { value: "INTEGER", label: "Number (Integer)" },
  { value: "DECIMAL_2", label: "Number (2 decimal)" },
  { value: "DECIMAL_4", label: "Number (4 decimal)" },
  { value: "DATE", label: "Date" },
  { value: "SELECT", label: "Select List (Custom)" },
  { value: "SELECT_ORDER_STATUS", label: "Order Status List" },
  { value: "REF_USER", label: "User List" },
  { value: "REF_PROVIDER", label: "Insurer / Provider List" },
  { value: "REF_PRODUCT_TYPE", label: "Product Type List" },
  { value: "BOOLEAN", label: "Boolean (Y/N)" },
  { value: "FILE", label: "Single File" },
  { value: "FILES", label: "Files" },
];

export const REF_SERVICE_FIELD_TYPES = new Set([
  "REF_USER",
  "REF_PROVIDER",
  "REF_PRODUCT_TYPE",
]);

export const isFileServiceFieldType = (fieldType) =>
  fieldType === "FILE" || fieldType === "FILES";

export const isMultiFileServiceFieldType = (fieldType) => fieldType === "FILES";

export const isRefServiceFieldType = (fieldType) =>
  REF_SERVICE_FIELD_TYPES.has(fieldType);

export const getServiceRefConfig = (fieldType) =>
  REF_ENTITY_CONFIG[fieldType] ?? null;

export const getServiceFieldNumberPrecision = (fieldType) => {
  if (fieldType === "INTEGER") return 0;
  if (fieldType === "DECIMAL_2") return 2;
  if (fieldType === "DECIMAL_4") return 4;
  return undefined;
};

export const slugifyServiceFieldKey = (label = "") =>
  String(label)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 60) || "field";
